export function deleteUndefinedObjectValues<T extends Record<string | number | symbol, unknown>>(obj: T) {
  for (const [key, value] of Object.entries(obj)) {
    if (value === undefined) {
      delete obj[key];
    }
  }
}
